export default __webpack_public_path__ + "images/fa9c1276fa586e9e6c150e5bf3b110a5.png";